import { t } from 'i18next';

import { ErrorResponseErrorItemCodePoi } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodePoi, string> => ({
  'poi:poi_not_found': t('poi.poiNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Point Of Interest (POI) hittades inte.',
  }),
  'poi:user_unauthorized': t('poi.userUnauthorized', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte åtkomst till punkten (POI).',
  }),
});
